import React, { useState, useEffect } from "react";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../../../env";

const UploadDocumentsForm = () => {
  const [unitTypeId, setUnitTypeId] = useState("1");
  const [propertyTypeId, setPropertyTypeId] = useState("");
  const [propertyId, setPropertyId] = useState("");
  const [roomTypeId, setRoomTypeId] = useState("");
  const [documentType, setDocumentType] = useState("photo");
  const [photoTypeId, setPhotoTypeId] = useState("1");
  const [docTypeId, setDocTypeId] = useState("1");
  const [description, setDescription] = useState("");
  const [isDefault, setIsDefault] = useState(1);
  const [file, setFile] = useState(null);

  const [unitTypes, setUnitTypes] = useState([]);
  const [unitNames, setUnitNames] = useState([]);
  const [roomTypes, setRoomTypes] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState("Hotel");

  const [documents, setDocuments] = useState([]);
  const [loadingDocuments, setLoadingDocuments] = useState(false);
  const [editId, setEditId] = useState(null);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [total, setTotal] = useState(0);

  const totalPages = Math.max(Math.ceil(total / limit), 1);

  const fetchUnitTypes = async () => {
    try {
      const res = await axios.get(`${REACT_APP_API_URL}api/property/unit-types`);
      if (res.data.success) {
        setUnitTypes(
          res.data.data.map((type) => ({
            id: type.PropertyTypeID,
            name: type.PropertyTypeName,
          }))
        );
      }
    } catch (err) {
      console.error("Unit types fetch failed:", err);
    }
  };

  const fetchUnits = async () => {
    try {
      const res = await axios.get(`${REACT_APP_API_URL}api/property/units`);
      if (res.data.success) {
        setUnitNames(
          res.data.data.map((unit) => ({
            id: unit.PropertyID,
            name: unit.UnitName,
          }))
        );
      }
    } catch (err) {
      console.error("Units fetch failed:", err);
    }
  };

  const fetchRoomTypes = async () => {
    if (selectedUnit !== "Room" || !propertyId) {
      setRoomTypes([]);
      return;
    }

    try {
      const res = await axios.post(`${REACT_APP_API_URL}api/property/get-unit-types`, {
        P_CHRACTION: "RT",
        P_INTPROPERTYID: propertyId,
      });

      if (res.data.success) {
        setRoomTypes(res.data.data || []);
      }
    } catch (err) {
      console.error("Room types fetch failed:", err);
    }
  };

  const fetchDocuments = async (pageNo = page, pageLimit = limit) => {
    try {
      setLoadingDocuments(true);

      const res = await axios.get(`${REACT_APP_API_URL}api/property/documents`, {
        params: {
          page: pageNo,
          limit: pageLimit,
        },
      });

      if (res.data.success) {
        setDocuments(res.data.data || []);
        setTotal(res.data.total || 0);
      }
    } catch (err) {
      console.error("Documents fetch failed:", err);
      setDocuments([]);
      setTotal(0);
    } finally {
      setLoadingDocuments(false);
    }
  };

  useEffect(() => {
    fetchUnitTypes();
    fetchUnits();
  }, []);

  useEffect(() => {
    fetchDocuments(page, limit);
  }, [page, limit]);

  useEffect(() => {
    fetchRoomTypes();
  }, [selectedUnit, propertyId]);

  const resetForm = () => {
    setEditId(null);
    setUnitTypeId("1");
    setPropertyTypeId("");
    setPropertyId("");
    setRoomTypeId("");
    setDocumentType("photo");
    setPhotoTypeId("1");
    setDocTypeId("1");
    setDescription("");
    setIsDefault(1);
    setFile(null);
    setSelectedUnit("Hotel");

    const fileInput = document.getElementById("documentFile");
    if (fileInput) fileInput.value = "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!propertyTypeId) {
      alert("Please select Unit Type");
      return;
    }

    if (!propertyId) {
      alert("Please select Unit Name");
      return;
    }

    if (selectedUnit === "Room" && !roomTypeId) {
      alert("Please select Room Type");
      return;
    }

    if (!editId && !file) {
      alert("Please upload file");
      return;
    }

    const formData = new FormData();
    formData.append("P_intUnitTypeID", unitTypeId);
    formData.append("P_intDefault", isDefault);
    formData.append("P_intPropertyID", propertyId);
    formData.append("P_intRoomTypeId", roomTypeId || 0);
    formData.append("P_vchDocumentType", documentType);
    formData.append("P_vchDescription", description);
    formData.append("P_INTCREATEDBY", 1);
    formData.append("P_intPropertyTypeId", propertyTypeId);
    formData.append("P_intPhotoTypeID", photoTypeId);
    formData.append("P_intDocumentType", docTypeId);

    if (file) {
      formData.append("photo", file);
    }

    try {
      const url = editId
        ? `${REACT_APP_API_URL}api/property/documents/${editId}`
        : `${REACT_APP_API_URL}api/property/upload`;

      const method = editId ? axios.put : axios.post;

      const res = await method(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      alert(res.data.message || "Saved successfully");
      resetForm();
      setPage(1);
      fetchDocuments(1, limit);
    } catch (err) {
      console.error("Save failed:", err);
      alert(err.response?.data?.message || "Save failed");
    }
  };

  const handleEdit = (doc) => {
    setEditId(doc.PropertyPhotoID);
    setUnitTypeId(String(doc.UnitTypeID || "1"));
    setPropertyTypeId(String(doc.PropertyTypeID || ""));
    setPropertyId(String(doc.PropertyID || ""));
    setRoomTypeId(String(doc.RoomTypeId || ""));
    setDocumentType(doc.DocumentType || "photo");
    setPhotoTypeId(String(doc.PhotoTypeID || "1"));
    setDocTypeId(String(doc.DocumentTypeID || "1"));
    setDescription(doc.Description || "");
    setIsDefault(doc.IsDefault ? 1 : 0);
    setSelectedUnit(Number(doc.UnitTypeID) === 2 ? "Room" : "Hotel");
    setFile(null);

    const fileInput = document.getElementById("documentFile");
    if (fileInput) fileInput.value = "";

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this document?"
    );

    if (!confirmDelete) return;

    try {
      const res = await axios.delete(
        `${REACT_APP_API_URL}api/property/documents/${id}`,
        {
          data: {
            P_INTCREATEDBY: 1,
          },
        }
      );

      alert(res.data.message || "Deleted successfully");

      if (String(editId) === String(id)) {
        resetForm();
      }

      fetchDocuments(page, limit);
    } catch (err) {
      console.error("Delete failed:", err);
      alert(err.response?.data?.message || "Delete failed");
    }
  };

  return (
    <div className="container mt-4">
      <div className="card shadow">
        <div className="card-header bg-primary text-white">
          <h3 className="mb-0">
            {editId ? "Edit Property Document" : "Upload Property Document"}
          </h3>
        </div>

        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="row mb-3">
              <div className="col-md-4">
                <label className="form-label">Unit</label>
                <br />

                <div className="form-check form-check-inline">
                  <input
                    type="radio"
                    value="1"
                    className="form-check-input"
                    checked={unitTypeId === "1"}
                    onChange={() => {
                      setUnitTypeId("1");
                      setSelectedUnit("Hotel");
                      setRoomTypeId("");
                    }}
                  />
                  <label className="form-check-label">Hotel</label>
                </div>

                <div className="form-check form-check-inline">
                  <input
                    type="radio"
                    value="2"
                    className="form-check-input"
                    checked={unitTypeId === "2"}
                    onChange={() => {
                      setUnitTypeId("2");
                      setSelectedUnit("Room");
                    }}
                  />
                  <label className="form-check-label">Room</label>
                </div>
              </div>

              <div className="col-md-4">
                <label className="form-label">Document Type</label>
                <select
                  className="form-select"
                  value={documentType}
                  onChange={(e) => setDocumentType(e.target.value)}
                >
                  <option value="photo">Photo</option>
                  <option value="document">Document</option>
                  <option value="virtual">Virtual Tour</option>
                  <option value="video">Video</option>
                </select>
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-4">
                <label className="form-label">Unit Type</label>
                <select
                  className="form-select"
                  value={propertyTypeId}
                  onChange={(e) => setPropertyTypeId(e.target.value)}
                >
                  <option value="">--Select--</option>
                  {unitTypes.map((type) => (
                    <option key={type.id} value={type.id}>
                      {type.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-4">
                <label className="form-label">Unit Name</label>
                <select
                  className="form-select"
                  value={propertyId}
                  onChange={(e) => {
                    setPropertyId(e.target.value);
                    setRoomTypeId("");
                  }}
                >
                  <option value="">--Select--</option>
                  {unitNames.map((unit) => (
                    <option key={unit.id} value={unit.id}>
                      {unit.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {selectedUnit === "Room" && (
              <div className="row mb-3">
                <div className="col-md-4">
                  <label className="form-label">Room Type</label>
                  <select
                    className="form-select"
                    value={roomTypeId}
                    onChange={(e) => setRoomTypeId(e.target.value)}
                  >
                    <option value="">--Select--</option>
                    {roomTypes.map((room) => (
                      <option
                        key={room.HotelRoomConfigID}
                        value={room.HotelRoomConfigID}
                      >
                        {room.HotelRoomConfigType}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )}

            <div className="row mb-3">
              <div className="col-md-4">
                <label className="form-label">Upload File</label>
                <input
                  id="documentFile"
                  type="file"
                  className="form-control"
                  onChange={(e) => setFile(e.target.files[0])}
                />
                {editId && (
                  <small className="text-muted">
                    New file select karoge to old file replace hoga.
                  </small>
                )}
              </div>

              <div className="col-md-2 d-flex align-items-end">
                <div className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={isDefault === 1}
                    onChange={(e) => setIsDefault(e.target.checked ? 1 : 0)}
                  />
                  <label className="form-check-label">Default</label>
                </div>
              </div>
            </div>

            <div className="row mb-4">
              <div className="col-md-6">
                <label className="form-label">Description</label>
                <textarea
                  className="form-control"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  maxLength={400}
                  placeholder="Max 400 characters"
                />
              </div>
            </div>

            <div className="d-flex justify-content-end gap-2">
              <button type="submit" className="btn btn-success">
                {editId ? "Update" : "Submit"}
              </button>

              <button type="button" className="btn btn-danger" onClick={resetForm}>
                Reset
              </button>
            </div>
          </form>
        </div>
      </div>

      <div className="card shadow mt-4">
        <div className="card-header bg-primary text-white">
          <h4 className="mb-0">Uploaded Documents</h4>
        </div>

        <div className="card-body">
          {loadingDocuments ? (
            <p className="mb-0">Loading...</p>
          ) : (
            <>
              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Unit Name</th>
                      <th>Document Type</th>
                      <th>Description</th>
                      <th>Default</th>
                      <th>File</th>
                      <th>Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {documents.length === 0 ? (
                      <tr>
                        <td colSpan="7" className="text-center">
                          No documents found
                        </td>
                      </tr>
                    ) : (
                      documents.map((doc, index) => (
                        <tr key={doc.PropertyPhotoID}>
                          <td>{(page - 1) * limit + index + 1}</td>
                          <td>{doc.UnitName || "-"}</td>
                          <td>{doc.DocumentType || "-"}</td>
                          <td>{doc.Description || "-"}</td>
                          <td>{doc.IsDefault ? "Yes" : "No"}</td>
                          <td>{doc.Photo || "-"}</td>
                          <td>
                            <button
                              type="button"
                              className="btn btn-sm btn-primary me-2"
                              onClick={() => handleEdit(doc)}
                            >
                              Edit
                            </button>

                            <button
                              type="button"
                              className="btn btn-sm btn-danger"
                              onClick={() => handleDelete(doc.PropertyPhotoID)}
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-2">
                <div>
                  <span className="me-2">Rows per page:</span>
                  <select
                    className="form-select d-inline-block"
                    style={{ width: "90px" }}
                    value={limit}
                    onChange={(e) => {
                      setLimit(Number(e.target.value));
                      setPage(1);
                    }}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </select>
                </div>

                <div>
                  Showing {documents.length ? (page - 1) * limit + 1 : 0} to{" "}
                  {Math.min(page * limit, total)} of {total}
                </div>

                <div className="d-flex gap-2">
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    disabled={page <= 1 || loadingDocuments}
                    onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
                  >
                    Previous
                  </button>

                  <span className="align-self-center">
                    Page {page} of {totalPages}
                  </span>

                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    disabled={page >= totalPages || loadingDocuments}
                    onClick={() =>
                      setPage((prev) => Math.min(prev + 1, totalPages))
                    }
                  >
                    Next
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default UploadDocumentsForm;